/* Ube Time — révélation au scroll (.reveal -> .in) + parallaxe légère */
(function () {
  // Marque que le JS est actif : le CSS peut alors masquer .reveal en toute sécurité
  // (sans JS, .reveal reste visible — voir ube-home.css).
  document.documentElement.classList.add('ube-js');

  var inEditor = window.Shopify && window.Shopify.designMode;

  function showAll(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (e) { e.classList.add('in'); });
  }

  function reveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;
    // Dans l'éditeur de thème : tout afficher immédiatement pour que le marchand
    // voie toujours son contenu (images, textes) dès qu'il le modifie.
    if (inEditor || !('IntersectionObserver' in window)) { showAll(root); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Filet de sécurité : si l'observer ne se déclenche pas (mesure/timing), on affiche.
    setTimeout(function () { showAll(root); }, 2500);
  }

  function parallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var amt = parseFloat(el.getAttribute('data-parallax')) || 0.05;
        var off = (r.top + r.height / 2 - vh / 2) * amt;
        el.style.transform = 'translateY(' + (-off).toFixed(1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function init() { reveal(); parallax(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Éditeur de thème : re-scanner quand une section est (re)chargée
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
